import type { Tone } from "Components/ui";

/** URL of each step; all of them render inside the same AuthLayout. */
export const AUTH_PATHS = {
  signIn: "/credentials",
  verify: "/credentials/verify",
  forgot: "/credentials/forgot",
  reset: "/credentials/reset",
} as const;

/** A pending password login waiting for its WhatsApp code. */
export interface LoginChallenge {
  userId: string;
  phoneHint: string | null;
  expiresInSeconds: number;
  resendAfterSeconds: number;
}

/** Message carried back to the sign-in step (expired code, password changed, session ended). */
export interface AuthNotice {
  tone: Tone;
  title: string;
  message?: string;
}

export interface AuthFlowState {
  /** Last username typed in any step, so the user never types it twice. */
  userName: string;
  challenge: LoginChallenge | null;
  notice: AuthNotice | null;
  /** Server confirmation for the reset code, e.g. "Code sent on WhatsApp to ••••3421". */
  resetSentMessage: string | null;
}
